import {HttpClient, HttpHeaders,} from '@angular/common/http';
import {Inject, Injectable, Optional} from '@angular/core';
import {Configuration} from '../configuration';
import {BASE_PATH} from '../variables';
import {ITU_CODE} from '@adlatus-gui/domain/clearing-custom';

@Injectable({
  providedIn: 'root'
})
export class ClearingTicketMigrationService {
  public baseConfigPath = '';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) baseConfigPath: string,
    @Optional() configuration: Configuration,
    @Inject(ITU_CODE) private ituCode: string[],
  ) {
    if (baseConfigPath) {
      this.baseConfigPath = baseConfigPath;
    }
    console.log(baseConfigPath)
    if (configuration) {
      this.configuration = configuration;
      this.baseConfigPath =
        baseConfigPath || configuration.basePath || this.baseConfigPath;
    }
    console.log(baseConfigPath)
  }

  public initiateMigration(receivingPlatform: string) {
    console.log(this.baseConfigPath)
    return this.httpClient.request<void>(
      'post',
      `${this.baseConfigPath}/internal/migration/migrate`,
      {
        body: receivingPlatform,
      }
    );
  }
}
